/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  DevicesImportControllerExportCsvParams,
  DevicesImportControllerExportCsvPathParameters,
  DevicesImportControllerExportDeviceCsvPathParameters,
  DevicesImportControllerImportCsvBody,
  DevicesImportControllerImportCsvParams,
  DevicesImportControllerImportCsvPathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class DevicesCsvV2Service {
  private readonly http = inject(HttpClient);
  /**
   * CSV export
   * @summary Export devices CSV
   */

  exportCsv<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DevicesImportControllerExportCsvPathParameters,
    params?: DevicesImportControllerExportCsvParams,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v2/clients/${clientId}/devices/export`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * CSV export for a single device (same format as bulk export; import-compatible)
   * @summary Export device CSV
   */

  exportDeviceCsv<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
  }: DevicesImportControllerExportDeviceCsvPathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v2/clients/${clientId}/devices/${deviceId}/export`);
  }
  /**
   * CSV import (SuperAdmin). Pass buildingId, floorId, roomId as query params.
   * @summary Import devices CSV
   */

  importCsv<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DevicesImportControllerImportCsvPathParameters,
    devicesImportControllerImportCsvBody: DevicesImportControllerImportCsvBody,
    params: DevicesImportControllerImportCsvParams,
  ): Observable<TData> {
    const formData = new FormData();
    formData.append(`file`, devicesImportControllerImportCsvBody.file);

    return this.http.post<TData>(`/devices/v2/clients/${clientId}/devices/import`, formData, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
}
